import { AnchorBottomDirective } from './anchorBottom.directive'
import { ButtonSpinnerDirective } from './button-spinner.directive'
import { FallBackImageDirective } from './fallbackImage.directive'
import { HasPrivilegeDirective } from './hasprivilege.directive'
import { HasSettingDirective } from '@shared/directives/hasSetting.directive'
import { IsEllipsisActiveDirective } from '@shared/directives/isEllipsisActive.directive'
import { NgModule } from '@angular/core'
import { ScrollSiblingsDirective } from '@shared/directives/scrollSiblings.directive'
import { TTLClassDirective } from './tmpclass.directive'

@NgModule({
  declarations: [
    TTLClassDirective,
    HasPrivilegeDirective,
    FallBackImageDirective,
    HasSettingDirective,
    AnchorBottomDirective,
    ScrollSiblingsDirective,
    IsEllipsisActiveDirective,
    ButtonSpinnerDirective,
  ],
  exports: [
    TTLClassDirective,
    HasPrivilegeDirective,
    FallBackImageDirective,
    HasSettingDirective,
    AnchorBottomDirective,
    ScrollSiblingsDirective,
    IsEllipsisActiveDirective,
    ButtonSpinnerDirective,
  ],
})
export class DirectivesModule {}
